export default __webpack_public_path__ + "static/media/logo.08577bf1.png";